<footer class="footer" id="footer">
  <nav class="footer-navigation mdc-layout-grid">
    <div class="footer-navigation-list footer-navigation-list-tablet-center">
      <ul>
        <li class="footer-navigation-list-item">
          <a [routerLink]="['legal/imprint']" (click)="closeMenu()" i18n="@@uiShell-imprintLinkLabel"> Impressum </a>
        </li>
        <li class="footer-navigation-list-item">
          <a [routerLink]="['legal/privacy-policy']" (click)="closeMenu()" i18n="@@uiShell-privacyPolicyLinkLabel">
            Datenschutz
          </a>
        </li>
        <li class="footer-navigation-list-item">
          <a
            [routerLink]="['legal/terms-and-conditions-of-use']"
            (click)="closeMenu()"
            i18n="@@uiShell-termsAndConditionsLinkLabel">
            AGB und Nutzungsbedingungen
          </a>
        </li>
        <li class="footer-navigation-list-item">
          <a [routerLink]="['contact']" (click)="closeMenu()" i18n="@@uiShell-contactLinkLabel"> Kontakt </a>
        </li>
        <li class="footer-navigation-list-item">
          <a
            href="https://bau-muenchen.com/de/besucher/informieren/newsletter/"
            target="_blank"
            (click)="closeMenu()"
            i18n="@@uiShell-newsletterLinkLabel"
            i18n-href="@@uiShell-newsletterLinkLabel-href">
            Newsletter
          </a>
        </li>
      </ul>
    </div>
    <div class="footer-navigation-list footer-navigation-mobile-meta">
      <ul>
        <li class="footer-navigation-list-item">
          <a
            class="footer-navigation-list-item-language"
            [matMenuTriggerFor]="languageMenu"
            (menuOpened)="triggerLanguageSwitch(true)"
            (menuClosed)="triggerLanguageSwitch(false)">
            <mat-icon class="icon-globe">globe</mat-icon>
            <ng-container i18n="@@uiShell-languageChoose-currentLanguage-textOnly">Deutsch</ng-container>
            <mat-icon class="icon-chevron-down" [class.footer-navigation-list-item-language-open]="languageSwitchOpen"
              >expand_more</mat-icon
            >
          </a>
          <mat-menu #languageMenu="matMenu">
            <a href="{{ '/de' + router.url }}" mat-menu-item>Deutsch</a>
            <a href="{{ '/en' + router.url }}" mat-menu-item>English</a>
          </mat-menu>
        </li>
      </ul>
    </div>
  </nav>
</footer>
<planone-back-to-top [showMobileBottomBar]="showMobileBottomBar"></planone-back-to-top>
